import React from "react";
import axios from "axios";
import { Image } from "react-img-placeholder";
import Dialog from "@mui/material/Dialog";
import { Buffer } from 'buffer';
import Avatar from "@mui/material/Avatar";

const imageCache = new Map();

export class ImageLoader extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            imageData: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEASABIAAD/2wBDA...", // Shortened default placeholder
            isOpen: false,
        };
    }

    handleShowDialog = () => {
        this.setState({ isOpen: true });
    };

    handleHideDialog = () => {
        this.setState({ isOpen: false });
    };

    componentDidMount() {
        this.loadImage(this.props.url);
    }

    async loadImage(url) {
        if (imageCache.has(url)) {
            this.setState({ imageData: imageCache.get(url) });
            return;
        }

        try {
            const response = await axios.get(url, {
                headers: { Authorization: 'Bearer ' + localStorage.getItem("pwa_messenger_token") },
                responseType: "arraybuffer",
            });
            const data = `data:${response.headers["content-type"]};base64,${Buffer.from(response.data, 'binary').toString('base64')}`;
            imageCache.set(url, data);
            this.setState({ imageData: data });
        } catch (error) {
            console.error("Image loading failed", error);
        }
    }

    render() {
        const { width = 64, height = 64 } = this.props;
        return (
            <div>
                <Avatar
                    key={this.props.url}
                    src={this.state.imageData}
                    sx={{ width: width, height: height, objectFit: 'cover', cursor: 'pointer' }}
                    alt="avatar"
                    onClick={this.handleShowDialog}
                />
                <Dialog open={this.state.isOpen} onClose={this.handleHideDialog}>
                    <div style={{ position: 'relative', backgroundColor: '#000', padding: 8, textAlign: 'center' }}>
                        <img
                            src="https://cdn-icons-png.flaticon.com/512/61/61155.png"
                            alt="close"
                            onClick={this.handleHideDialog}
                            style={{ position: 'absolute', top: 8, right: 8, width: 24, height: 24, cursor: 'pointer' }}
                        />
                        <img
                            src={this.state.imageData}
                            alt="zoomed avatar"
                            style={{
                                maxWidth: '90vw',
                                maxHeight: '90vh',
                                objectFit: 'contain',
                                margin: 'auto'
                            }}
                        />
                        <a
                            href={this.state.imageData}
                            download="image.jpg"
                            style={{
                                position: 'absolute',
                                bottom: 8,
                                right: 8,
                                backgroundColor: '#fff',
                                padding: '6px 12px',
                                borderRadius: 4,
                                textDecoration: 'none',
                                fontWeight: 'bold'
                            }}
                        >
                            Save
                        </a>
                    </div>
                </Dialog>
            </div>
        );
    }
}
